import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface UpdateCorporateDefaultBillableRateDto {
  scopeOfPractice: ScopeOfPracticeEnum;

  /**
   * format: double
   * minimum: 0.01
   * maximum: 1000
   */
  hourlyRate: number;

  /**
   * format: double
   * minimum: 0.01
   * maximum: 1000
   */
  urgentHourlyRate?: number;

  scheduledRates?: UpdateCorporateScheduledBillableRateDto[];
}

export interface UpdateCorporateScheduledBillableRateDto {
  /**
   * format: uuid
   */
  id?: string;

  /**
   * format: double
   * minimum: 0.01
   * maximum: 1000
   */
  rate: number;

  /**
   * format: date-time
   */
  effectiveFrom: string;

  /**
   * format: date-time
   */
  effectiveTo: string;
}
